import React, { useState, useCallback, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Form, { Item, Label, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import axios from 'axios';

import './ResetPassword.scss';

export const ResetPasswordPage = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [formData] = useState({ newPassword: '', confirmPassword: '' });

  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const token = params.get('token') ?? '';
  const email = params.get('email') ?? '';

  const onSubmit = useCallback(async(e: React.FormEvent) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      notify('Wachtwoorden komen niet overeen.', 'error', 3000);
      return;
    }

    if (formData.newPassword.length < 8) {
      notify('Wachtwoord moet minimaal 8 tekens lang zijn.', 'error', 3000);
      return;
    }

    setLoading(true);
    try {
      await axios.post('/api/Authentication/ResetPassword', {
        email,
        token,
        newPassword: formData.newPassword,
      });
      setSuccess(true);
    } catch (err: any) {
      const msg = err?.response?.data ?? 'Er is een fout opgetreden. Probeer het later opnieuw.';
      notify(msg, 'error', 4000);
    } finally {
      setLoading(false);
    }
  }, [formData, email, token]);

  if (!token || !email) {
    return (
      <div className='reset-password-page'>
        <div className='reset-card'>
          <h2>Ongeldige link</h2>
          <p className='reset-description'>Deze wachtwoord-herstellink is ongeldig of onvolledig.</p>
          <Link to='/login' className='back-link'>Terug naar inloggen</Link>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className='reset-password-page'>
        <div className='reset-card'>
          <h2>Wachtwoord gewijzigd!</h2>
          <p className='reset-description'>Uw wachtwoord is succesvol gewijzigd. U kunt nu inloggen met uw nieuwe wachtwoord.</p>
          <Link to='/login' className='back-link'>Ga naar inloggen</Link>
        </div>
      </div>
    );
  }

  return (
    <div className='reset-password-page'>
      <div className='reset-card'>
        <h2>Nieuw wachtwoord instellen</h2>
        <p className='reset-description'>Kies een nieuw wachtwoord voor uw account.</p>
        <form onSubmit={onSubmit}>
          <Form formData={formData} disabled={loading} showColonAfterLabel={false} showRequiredMark={false}>
            <Item dataField='newPassword' editorType='dxTextBox' editorOptions={{ stylingMode: 'filled', placeholder: 'Nieuw wachtwoord', mode: 'password' }}>
              <RequiredRule message='Wachtwoord is verplicht' />
              <Label visible={false} />
            </Item>
            <Item dataField='confirmPassword' editorType='dxTextBox' editorOptions={{ stylingMode: 'filled', placeholder: 'Bevestig wachtwoord', mode: 'password' }}>
              <RequiredRule message='Bevestig uw wachtwoord' />
              <Label visible={false} />
            </Item>
            <ButtonItem>
              <ButtonOptions width='100%' type='default' useSubmitBehavior>
                <span className='dx-button-text'>
                  {loading ? <LoadIndicator width='24px' height='24px' visible /> : 'Wachtwoord wijzigen'}
                </span>
              </ButtonOptions>
            </ButtonItem>
          </Form>
        </form>
        <Link to='/login' className='back-link'>Terug naar inloggen</Link>
      </div>
    </div>
  );
};
